var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongWendang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tongyong_wendang_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42 2v12a1 1 0 001 1h9.16a1 1 0 001-1V5.393a1 1 0 00-.3-.715l-3.467-3.393a1 1 0 00-.7-.285H4.42a1 1 0 00-1 1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.384 12.5a.5.5 0 100-1v1zm-5-1a.5.5 0 000 1v-1zm2-1a.5.5 0 000-1v1zm-2-1a.5.5 0 000 1v-1zm3.63-4h-.5a.5.5 0 00.5.5v-.5zm1.37 6h-5v1h5v-1zm-3-2h-2v1h2v-1zm1.13-8v4h1v-4h-1zm.5 4.5h4.059V5h-4.059v1zm.8-4.715l-.7.715.7-.715zm3.465 3.393l-.7.715.7-.715zM4.42 14V2h-2v12h2zm9.16 0H4.42v2h9.16v-2zM4.42 2h5.694V0H4.42v2zm9.16 3.393V14h2V5.393h-2zM10.114 2l3.466 3.393 1.399-1.43L11.513.571 10.113 2zm5.466 3.393a2 2 0 00-.601-1.43l-1.4 1.43h2zM10.114 2L11.513.57a2 2 0 00-1.4-.57v2zM2.42 14a2 2 0 002 2v-2h-2zm11.16 2a2 2 0 002-2h-2v2zM4.42 2V0a2 2 0 00-2 2h2z",
    fill: "#3F465C",
    mask: "url(#tongyong_wendang_svg__a)"
  })));
}
export default __webpack_public_path__ + "static/tongyong_wendang.c53acb88.svg";
export { SvgTongyongWendang as ReactComponent };